import { CREATED_BY_QUERY } from "@app/shared/users/users/queries/created-by.query";
import { VEHICLE_BLOCK_VEHICLE_QUERY } from "./vehicle-block-vehicle.query";
import { VEHICLE_BLOCK_TYPE_DROPDOWN_QUERY } from "@app/applications/movements-management/shared/vehicle-block-type/queries/vehicle-block-type-dropdown.query";

/** GraphQL selection for the vehicle block form. */
export const VEHICLE_BLOCK_FORM_QUERY = `
  id
  entityId
  type { ${VEHICLE_BLOCK_TYPE_DROPDOWN_QUERY} }
  vehicle { ${VEHICLE_BLOCK_VEHICLE_QUERY} }
  startAt
  expectedEndAt
  endedAt
  files { key name uploadedAt uploadedBy { id name avatar } }
  enabled
  status
  timeStatus
  createdAt
  updatedAt
  createdBy { ${CREATED_BY_QUERY} }
  canRescheduleVehicleBlock
  canRescheduleVehicleBlockStartDate
  canRemoveVehicleBlockFiles
  canCloseVehicleBlock
  canReopenVehicleBlock
  canCancelVehicleBlock
  canDisable
  canEnable
  canDelete
`;
